import React from 'react';
import { Box } from '@mui/material';
import { useDispatch } from 'react-redux';
import * as actions from '../../../../store/actions';

type Props = {
  event: {
    title: string,
    quantity: number,
  },
  userId: string,
  date: string,
  completed: boolean,
}

const CalendarEvent: React.FC<Props> = ({ event, userId, date, completed }) => {
  const dispatch = useDispatch();

  const onClickHandler = () => {
    dispatch(actions.scheduledServicesSelectUserAndDate({userId, date}));
    dispatch(actions.scheduledServicesOpenCloseServicesByUserAndDayModal(completed));
  }

  const colors = completed ? 
    { backgroundColor: '#a6dbbc', text: '#11823b', border: '1px solid #11823b'}
    : { backgroundColor: 'rgba(2, 136, 209, 0.30)', text: '#01579B', border: '1px solid #0288D1'};

  return (
    <Box sx={{...styles.eventContainer, backgroundColor: colors.backgroundColor, border: colors.border }} onClick={onClickHandler}>
      <Box sx={{...styles.text, color: colors.text }}>({event.quantity}) {event.title}</Box>
    </Box>
  )
};

export default CalendarEvent;

const styles = {
  eventContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    padding: '0px 5px',
    borderRadius: '3px',
    cursor: 'pointer',
    marginBottom: '1px',
    height: '27px'
  },
  text: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: 14,
  },
  iconContainer: {
    width: '15px',
    paddingTop: '5px'
  },
}